angular.module('ui-ng-ax')
  .factory('phxAxContainFocusServant', function phxAxContainFocusService() {
    const focusableElementsString = "a[href], area[href], fieldset[role=radiogroup], input:not([type=radio]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex]:not([disabled]), *[contenteditable]:not([disabled])";
    
    // account for fieldsets always being index -1
    const getSpecialFocus = (item) => {
      if (item.nodeName === 'FIELDSET') {
        item = item.elements[0];
      }
      return item;
    };

    // undo fieldset children focus
    const correctForSpecialFocus = (focusItem, focusList) => {
      if (_.result(focusItem[0], 'type') === 'radio') {
        focusItem = _.filter(focusList, (item) => {
          return item.nodeName === 'FIELDSET'
        })
      }
      return focusItem;
    };

    // construct focusables
    const focusable = (elementList) => {
      let isFocusableList = elementList.filter(focusableElementsString).filter(':visible');
      let size = isFocusableList.length - 1;
      return {
        list: isFocusableList,
        first: isFocusableList[0],
        last: isFocusableList[size],
        size: size
      }
    };

    return {  
      focusableElementsString: focusableElementsString,
      trapFocus: function (obj) {
        const TABKEYCODE = 9;
        obj = angular.element(obj);
        obj.on('keydown', function (evt) {
          if (evt.which == TABKEYCODE) {
            let o = obj.find('*');
            let focusableItems = focusable(o);
            let focusedItem = _.first(correctForSpecialFocus(angular.element(':focus'), focusableItems.list));
            let movedFocus;

            // reverse wrapping
            if (evt.shiftKey) {
              if (focusedItem === focusableItems.first) {
                movedFocus = getSpecialFocus(focusableItems.last);
                movedFocus.focus();
                evt.preventDefault();
              }

            } else {
              // forward wrapping
              if (focusedItem === focusableItems.last) {
                movedFocus = getSpecialFocus(focusableItems.first);
                movedFocus.focus();
                evt.preventDefault();
              }
            }
          }
        }) 
      }
    }
  });



// WEBPACK FOOTER //
// phx_ax_contain_focus.es.js